import { homerunnerApiBaseUrl } from '../../hr'
import { okOrThrow } from '../../common/http'
import { useQuery } from '@tanstack/react-query'
import { ExploreProperty, ExplorePagination } from '../explorer/data'
import { RelatedPropertiesFilter } from './config'

export type RelatedPropertiesResponse = {
  status: 'ok' | 'error'
  result: ExploreProperty[]
  pagination: ExplorePagination
}

export async function fetchRelatedProperties(
  feedId: number,
  filter: RelatedPropertiesFilter,
  page: number = 1,
): Promise<RelatedPropertiesResponse> {
  const url = new URL(`${homerunnerApiBaseUrl()}/public-api/v1/${feedId}/feed/related-properties`)
  // Use `slug` instead of `property`: the central auth.public.v1 middleware
  // intercepts `?property=` as a Property UUID and 404s before the controller runs.
  if (filter.property) url.searchParams.append('slug', filter.property)
  url.searchParams.append('limit', String(filter.limit ?? 3))
  url.searchParams.append('page', String(page))
  if (filter.platform) url.searchParams.append('platform', filter.platform)
  if (filter.types) url.searchParams.append('types', filter.types)
  if (filter.amenities) url.searchParams.append('amenities', filter.amenities)
  if (filter.guests != null) url.searchParams.append('guests', String(filter.guests))

  const res = await fetch(url.toString())
  await okOrThrow(res, 'Failed to fetch related properties')
  return (await res.json()) as RelatedPropertiesResponse
}

export function useFetchRelatedProperties(feedId: number, filter: RelatedPropertiesFilter) {
  return useQuery({
    queryKey: ['related-properties', feedId, filter],
    queryFn: () => fetchRelatedProperties(feedId, filter, 1),
    enabled: Boolean(filter.property),
  })
}
